import { render } from "./waitinglistview.vue?vue&type=template&id=21321a88"
import script from "./waitinglistview.vue?vue&type=script&lang=js"
export * from "./waitinglistview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__